export const getPageTitle = (pathname) => {
  let pageTitle = '';
  switch (pathname) {
    case '/academylist':
      pageTitle = 'Academy List';
      break;
    case '/disabledAcademy':
      pageTitle = 'Disabled Academy';
      break;
    case '/courtCreation':
      pageTitle = 'Court Creation';
      break;
    case '/departmentAndJob':
      pageTitle = 'Department And Roles';
      break;
    case '/departmentAndRolesCreation':
      pageTitle = 'Department And Roles Creation ';
      break;
    case '/employeeHr':
      pageTitle = 'Employee List';
      break;
    case '/employeeCreation':
      pageTitle = "Employee Creation";
      break;
    case '/employeeHrReport':
      pageTitle = 'Employee Attendance';
      break;
    case '/buy-plan':
      pageTitle = 'Buy Plan';
      break;
    case '/careerApplications':
      pageTitle = 'Career Applicants';
      break;
    case '/perCourtUtilization':
      pageTitle = 'Court Utilization';
      break;
    case '/cmTeamRevenue':
      pageTitle = 'CM Team Revenue';
      break;
    case '/reconciliationReport':
      pageTitle = 'Reconciliation Report';
      break;
    case '/newPlayingSubscription':
      pageTitle = 'Playing Subscription';
      break;
    case '/coachAttendance':
      pageTitle = 'Coach Attendance';
      break;
    case '/taskTracking':
      pageTitle = 'Activity Tracking';
      break;
    case '/sportBenefit':
      pageTitle = 'Sport Benefit';
      break;
    case '/createCourtPricing':
      pageTitle = 'Create Court Pricing';
      break;
    case '/courtPricing':
      pageTitle = 'Court Pricing';
      break;
    case '/academyFeatures':
      pageTitle = 'Academy Features';
      break;
    case '/newAcademyFeatures':
      pageTitle = 'New Academy Features';
      break;
    case '/courtType':
      pageTitle = 'Court Type';
      break;
    case '/ActivityLog':
      pageTitle = 'Activity Log';
      break;
    case '/newAcademy':
      pageTitle = 'New Academy';
      break;
    case '/guestUser':
      pageTitle = 'Guest User';
      break;
    case '/playerDetails':
      pageTitle = 'Player Details';
      break;
    case '/family':
      pageTitle = 'Family';
      break;
    case '/walkInSalesRecords':
      pageTitle = 'Walk In Sales Records';
      break;
    case '/createPass':
      pageTitle = 'Create Pass';
      break;
    case '/passList':
      pageTitle = 'Pass List';
      break;
    case '/cashTracking':
      pageTitle = 'Cash Tracking';
      break;
    case '/addPlayerPayment':
      pageTitle = 'Add Player Payment';
      break;
    case '/addPlayerBatch':
      pageTitle = 'Add Player Batch';
      break;
    case '/create-role':
      pageTitle = 'Create Role';
      break;
    case '/create-user':
      pageTitle = 'Create User';
      break;
    case '/RoleList':
      pageTitle = 'Role List';
      break;
    case '/UserList':
      pageTitle = 'User List';
      break;
    case '/sportList':
      pageTitle = 'Sport List';
      break;
    case '/newSport':
      pageTitle = 'New Sport';
      break;
    case '/coupon':
      pageTitle = 'CouponList';
      break;
    case '/newCoupon':
      pageTitle = 'New Coupon';
      break;
    case '/dues':
      pageTitle = 'Dues';
      break;
    case '/paymentlist':
      pageTitle = 'Payment List';
      break;
    case '/summary':
      pageTitle = 'Summary';
      break;
    case '/sportPaymentsummary':
      pageTitle = 'Sport Payment Summary';
      break;
    case '/academyPlayerList':
      pageTitle = 'Academy Player List';
      break;
    case '/academyCoachList':
      pageTitle = 'Academy Coach List';
      break;
    case '/createNewBatch':
      pageTitle = 'Create New Batch';
      break;
    case '/createNewPlayer':
      pageTitle = 'Create New Player';
      break;
    case '/batchList':
      pageTitle = 'Batch List';
      break;
    case '/playerBatch':
      pageTitle = 'Player Batch';
      break;
    case '/coachBatch':
      pageTitle = 'Coach Batch';
      break;
    case '/batchCancellation':
      pageTitle = 'Batch Cancellation';
      break;
    case '/cancelBatchList':
      pageTitle = 'Cancelled Batch List';
      break;
    case '/tournamentList':
      pageTitle = 'Tournament List';
      break;
    case '/createTournament':
      pageTitle = 'Create Tournament';
      break;
    case '/academyfeedback':
      pageTitle = 'Academy Feedback';
      break;
    case '/challengeList':
      pageTitle = 'Challenge List';
      break;
    case '/notification':
      pageTitle = 'Notification';
      break;
    case '/planList':
      pageTitle = 'Plan List';
      break;
    case '/oldPlanList':
      pageTitle = 'Old Plan List';
      break;
    case '/oldPlan':
      pageTitle = 'Old Plan';
      break;
    case '/newPlan':
      pageTitle = 'New Plan';
      break;
    case '/courtlist':
      pageTitle = 'Court List';
      break;
    case '/bookingcalendar':
      pageTitle = 'Booking Calendar';
      break;
    case '/courtbookings':
      pageTitle = 'Court Bookings';
      break;
    case '/courtprice':
      pageTitle = 'Court Price';
      break;
    case '/courtbulkbooking':
      pageTitle = 'Court Bulk Booking';
      break;
    case '/bulkbookinglist':
      pageTitle = 'Bulk Booking List';
      break;
    case '/newcourt':
      pageTitle = 'New Court';
      break;
    case '/blockcourt':
      pageTitle = 'Block Court List';
      break;
    case '/academygallery':
      pageTitle = 'Academy Gallery';
      break;
    case '/detailsAttendance':
      pageTitle = 'Detail Attendance';
      break;
    case '/bankdetails':
      pageTitle = 'Bank Details';
      break;
    case '/editprofile':
      pageTitle = 'Edit Profile';
      break;
    case '/feesSetting':
      pageTitle = 'Fees Setting';
      break;
    case '/resetPassword':
      pageTitle = 'Reset Password';
      break;
    case '/razorpayauth':
      pageTitle = 'Razorpay Auth';
      break;
    case '/searchuser':
      pageTitle = 'Search User';
      break;
    case '/sliderlist':
      pageTitle = 'Slider List';
      break;
    case '/newslider':
      pageTitle = 'New Slider';
      break;
    case '/checkinreport':
      pageTitle = 'Center CheckIn Report';
      break;
    case '/courtlights':
      pageTitle = 'Court Lights';
      break;
    case '/couponsusagereport':
      pageTitle = 'Coupons Usage Report';
      break;
    case '/viewPerformance':
      pageTitle = 'View Performance';
      break;
    case '/walkinenquiry':
      pageTitle = 'Walk-in enquiries';
      break;
    case '/walkInEnrollment':
      pageTitle = 'Walk-in Enrollment';
      break;
    case '/walkInFormEnquiry':
      pageTitle = ' Walk-in enquiry form';
      break;
    case '/setGuardianPlayer':
      pageTitle = 'Set Guardian Player';
      break;
    case '/learntrailreports':
      pageTitle = 'Learn Trial Reports';
      break;
    case '/leavereport':
      pageTitle = 'Leave Report';
      break;
    case '/loginreport':
      pageTitle = 'Login Report';
      break;
    case '/playingsubscription':
      pageTitle = 'Playing Subscription';
      break;
    case '/playtrailreport':
      pageTitle = 'Play Trial Report';
      break;
    case '/rewardDuesfamily':
      pageTitle = 'Reward Dues Family';
      break;
    case '/benfit':
      pageTitle = 'Benefit List';
      break;
    case '/createbenefit':
      pageTitle = 'New Benefit';
      break;
    case '/addunavailableDate':
      pageTitle = 'Add Unavailable Date';
      break;
    case '/curriculum':
      pageTitle = 'Curriculum';
      break;
    case '/summerEnrollmentForm':
      pageTitle = 'Summer Enrollment Form';
      break;
    case '/walkInSales':
      pageTitle = 'Walk In Sales';
      break;
    case '/slotDetails':
      pageTitle = 'Slot Details';
      break;
    case '/dailyRevenueReport':
      pageTitle = 'Daily Revenue Report';
      break;
    case '/dailyUtilisationReport':
      pageTitle = 'Daily Utilisation Report';
      break;
    case '/checkinDetails':
      pageTitle = 'Checkin Details';
      break;
    case '/setGuardian':
      pageTitle = 'Set Guardian';
      break;
    case '/playerAttendance':
      pageTitle = 'Player Attendance';
      break;
    case '/newPerformance':
      pageTitle = 'Player Performance';
      break;
    case '/playerCoachList':
      pageTitle = 'Player Coach List';
      break;
    case '/activePlayer':
      pageTitle = 'Active Player';
      break;
    case '/unavailableDate':
      pageTitle = 'Unavailable Date';
      break;
    case '/playerpaymentDetail':
      pageTitle = 'Player Payment Detail';
      break;
    case '/customization':
      pageTitle = 'Landing Page Customization';
      break;
    case '/leadmanagement':
      pageTitle = 'Lead Management';
      break;
    case '/dashboard':
      pageTitle = 'Lead Dashboard';
      break;
    case '/ticket':
      pageTitle = 'Ticket';
      break;
    case '/ticketReport':
      pageTitle = 'Ticket Report';
      break;
    case '/SubCategoryCreation':
      pageTitle = 'Sub Category Creation';
      break;
    case '/CategoryCreation':
      pageTitle = 'Category Creation';
      break;
    case '/newticket':
      pageTitle = 'New Ticket';
      break;
    case '/employee':
      pageTitle = 'Employee';
      break;
    case '/ticketcategory':
      pageTitle = 'Ticket Category';
      break;
    case '/ticketSubCategory':
      pageTitle = 'Ticket SubCategory';
      break;
    case '/createEmployee':
      pageTitle = 'Create Employee';
      break;
    case '/PeakHour':
      pageTitle = 'Peak Hour';
      break;
    case '/SportWiseRevenue':
      pageTitle = 'SportWise Revenue';
      break;
    case '/RevenueRatio':
      pageTitle = 'Revenue Ratio';
      break;
    case '/CourtUsage':
      pageTitle = 'Court Usage';
      break;
    case '/RepeatRate':
      pageTitle = 'Repeat Rate';
      break;
    case '/Enquiry':
      pageTitle = 'Enquiry';
      break;
    case '/Summer':
      pageTitle = 'Summer Camp  Enrollment Data';
      break;
    case '/SummerColdLead':
      pageTitle = 'Dropoffs Of Summer Camp';
      break;
    case '/coldleads':
      pageTitle = 'Junk Leads';
      break;
    case '/Trialrescheduled':
      pageTitle = 'Trial Rescheduled';
      break;
    case '/Trialmissed':
      pageTitle = 'Trial Missed';
      break;
    case '/Trialattended':
      pageTitle = 'Trial Attended';
      break;
    case '/Trialconverted':
      pageTitle = 'Trial Converted';
      break;
    case '/bookingConfirmation':
      pageTitle = 'Booking Confirmation';
      break;
    case '/salesRegister':
      pageTitle = 'Sales Register';
      break;
    case '/CreateCoach':
      pageTitle = 'Create Coach';
      break;
    case '/ProgresAttribute':
      pageTitle = 'Progress Attribute';
      break;
    case '/newProgress':
      pageTitle = 'New Progress';
      break;
    case '/AttributeQa':
      pageTitle = 'Attribute QA';
      break;
    case '/ProgessParameter':
      pageTitle = 'Progress Parameter';
      break;
    case '/newAttribute':
      pageTitle = 'New Attribute QA';
      break;
    case '/newProgessParameter':
      pageTitle = 'New Progress Parameter';
      break;
    case '/settlePayment':
      pageTitle = 'Settle Payment';
      break;
    case '/createPlayer':
      pageTitle = 'Create Player';
      break;
    case '/shop':
      pageTitle = 'Shop';
      break;
    case '/newGallery':
      pageTitle = 'New Gallery';
      break;
    case '/newReferee':
      pageTitle = 'New Referee';
      break;
    case '/Referee':
      pageTitle = 'Referee';
      break;
    case '/sms':
      pageTitle = 'SMS';
      break;
    case '/profile':
      pageTitle = 'Profile';
      break;
    case '/performance':
      pageTitle = 'Performance';
      break;

    case '/coachFeedback':
      pageTitle = 'Coach Feedback';
      break;
    case '/dropouts':
      pageTitle = 'Dropouts';
      break;
    case '/createCoach':
      pageTitle = 'Create Coach';
      break;
    case '/coachList':
      pageTitle = 'Coach List';
      break;
    case '/batchPlayerList':
      pageTitle = 'Batch Player List';
      break;
    case '/newEnrollments':
      pageTitle = 'New Enrollments';
      break;
    case '/userFeedback':
      pageTitle = 'User Feedback';
      break;

    case '/Curriculum"':
      pageTitle = 'Curriculum"';
      break;
    case '/createCirriculum':
      pageTitle = 'Create Cirriculum';
      break;
    case '/category':
      pageTitle = 'Category';
      break;
    case '/drills':
      pageTitle = 'Drills';
      break;
    case '/createDrills':
      pageTitle = 'Create Drills';
      break;
    case '/createCategory':
      pageTitle = 'Create Category';
      break;
    case '/setPlayer':
      pageTitle = 'Set Player';
      break;
    case '/Curriculum':
      pageTitle = 'Curriculum';
      break;
    case '/tierCreation':
      pageTitle = 'Tier Creation';
      break;
    case '/tierList':
      pageTitle = 'Tier List';
      break;
    case '/winterSales':
      pageTitle = '❄️ Winter Sales';
      break;
    case '/userRewards':
      pageTitle = 'User Rewards';
      break;
    default:
      pageTitle = 'Dashboard';
  }

  return pageTitle;
};